import { render, staticRenderFns } from "./ShippingPrice.vue?vue&type=template&id=2988fcd6&"
import script from "./ShippingPrice.vue?vue&type=script&lang=js&"
export * from "./ShippingPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports